import Paper from '@mui/material/Paper'
import { styled } from '@mui/system'

const RightBottomPaper = styled(Paper)(({ theme }) => ({
  // TODO: zIndex is unknow type??
  zIndex: (theme.zIndex as any).drawer,
  position: 'fixed',
  width: 400,
  right: theme.spacing(1),
  bottom: theme.spacing(1),
}))

export default RightBottomPaper
